import _merge from "lodash/merge";
import _pick from "lodash/pick";
import { sessionTypes } from "../session";

const initialState = {
    audiences: {},
    companies: {},
    ctas: {},
    devices: {},
    industries: {},
    pageResults: {},
    pages: {},
    segments: {},
    teams: {},
    users: {},
    wevoAudiences: {},
    wevoResults: {},
    wevos: {},
    wevoSegments: {}
};

export default function entities(state = initialState, action) {
    if (action.type === sessionTypes.RESET_AUTH) {
        return _merge(
            {},
            initialState,
            _pick(state, ["audiences", "devices", "industries", "segments"])
        );
    }
    if (action.entities) {
        // Each property in `state` stores an object that contains entities indexed by their id. `action.entities`
        // has the same structure for the entities we just got. We want to replace each entity in `state` with its
        // updated entity from `action.entities`.
        const newState = Object.keys(action.entities).reduce(
            (newState, entityKey) => {
                const existingEntities = state[entityKey] || {};
                const updatedEntities = action.entities[entityKey];

                // merge the updated entities into the existing entities without modifying either of them
                // (this is important!)
                newState[entityKey] = {
                    ...existingEntities,
                    ...updatedEntities
                };
                return newState;
            },
            {}
        );

        // Merge the modified entity dictionaries into the existing ones. This makes sure that don't lose dictionaries
        // that weren't updated by this action.
        return { ...state, ...newState };
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/modules/entities/reducers.js